<div class="ibox">
  <iboxtools
        *ngIf="banco != null"
        [Title]=""
        [isHistory]=true
        [DateInit]="banco?.desde"
        [DateEnd]="banco?.hasta"
        [PeriodList]="datosBancariosHistoryList"
        [IsEditing]="isEditing"
        (PeriodChange)="OnPeriodChange($event)"
        (NewChange)="OnNewChange($event)"
        (EditChange)="OnEditChange($event)"
        (SaveChange)="OnSaveChange($event)"
        (CutChange)="OnCutChange($event)"
        (DeleteChange)="OnDeleteChange($event)"
        (CancelChange)="OnCancelChange($event)"
        [Permiso]="permisoEdicion"
   ></iboxtools> 
   <div class="ibox-content" *ngIf="banco != null"> 
     <mat-error *ngIf="bancosInvalida" class="bancosInvalida">{{MensajeError}}</mat-error>
     <form [formGroup]="form">
       <div class="row" hidden="true">
         <input formControlName="id" name="id" type="text" class="form-control" />
         <input formControlName="personal" name="personal" type="text" class="form-control" />
         <input formControlName="alias" name="alias" type="text" class="form-control" />
       </div>
       <div class="row panel panel-warning" *ngIf="!disabledEditing">
         <div class="col-lg">
           <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
           <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl></p-calendar>
            <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error *ngIf="registerFormControl.desde.errors?.desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
            </mat-error>
            <mat-error *ngIf="registerFormControl.desde.errors?.anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al límite de retroactividad {{gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
            </mat-error>
           </div>
         </div>
         <div class="col-lg">

           <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
           <div class="col-lg-8">
             <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl></p-calendar>
             <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
             <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
              La Fecha no puede ser menor que la Fecha Desde
             </mat-error>
           </div>
         </div>
       </div>
       <div class="row">
         <div class="col-md-6">
           <label class="col-form-label font-bold">Banco</label>
           <div>
             <comboTools [list]=bancoList
                         selected='banco'
                         [formParent]="form"
                         [isEditing]=disabledEditing
                         filter="descripcion"></comboTools>
             <div *ngIf="registerFormControl.banco.invalid && (registerFormControl.banco?.dirty || registerFormControl.banco?.touched || submitted)" class="text-danger">
               El Banco es Requerido
             </div>
           </div>
         </div>
         <div class="col-md-6">
          <div class="form-group">
            <label class=" col-form-label font-bold">CBU</label>
            <input formControlName="cbu" maxlength="50" name ="selectedCbu" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.cbu.errors && (registerFormControl.cbu?.dirty || registerFormControl.cbu?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.cbu.errors?.required && (registerFormControl.cbu?.dirty || registerFormControl.cbu?.touched || submitted)">
                El CBU es Requerido
            </mat-error>
          </div>
         </div>
       </div>
       <div class="row">
         <div class="col-md-12">
          <div class="form-group">
            <label class=" col-form-label font-bold">Cuenta Bancaria</label>
            <input formControlName="cuentaBancaria" maxlength="50" name ="selectedCuenta" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.cuentaBancaria.errors && (registerFormControl.cuentaBancaria?.dirty || registerFormControl.cuentaBancaria?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.cuentaBancaria.errors?.required && (registerFormControl.cuentaBancaria?.dirty || registerFormControl.cuentaBancaria?.touched || submitted)">
                La Cuenta Bancaria es Requerida
            </mat-error>
          </div>
         </div>
       </div>
       <div class="row">
         <div class="col-md-6">
           <label class="col-form-label font-bold">Vía de Pago</label>
           <div>
             <comboTools [list]=pagoList
                         selected='viaPago'
                         [formParent]="form"
                         [isEditing]=disabledEditing
                         filter="descripcion"></comboTools>
             <div *ngIf="registerFormControl.viaPago.invalid && (registerFormControl.viaPago?.dirty || registerFormControl.viaPago?.touched || submitted)" class="text-danger">
               La Via de Pago es Requerida
             </div>
           </div>
         </div>
         <div class="col-md-6">
           <label class="col-form-label font-bold">Moneda</label>
           <div>
             <comboTools [list]=monedasList
                         selected='moneda'
                         [formParent]="form"
                         [isEditing]=disabledEditing
                         filter="descripcion"></comboTools>
             <div *ngIf="registerFormControl.moneda.invalid && (registerFormControl.moneda?.dirty || registerFormControl.moneda?.touched || submitted)" class="text-danger">
               La Moneda es Requerida
             </div>
           </div>
         </div>
       </div>
     </form>
   </div>
</div>

<div class="ibox-content m-b-sm border-bottom" *ngIf="banco == null && cargaCompleta">
  <button type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
  <div class="p-xs">
    <div class="float-left m-r-md">
      <i class="fa fa-globe text-navy mid-icon"></i>
    </div>
    <h2>Empleado sin Banco</h2>
    <span>El empleado no tiene Bancos.</span>
  </div>
</div>
